import { defineComponent as _defineComponent } from 'vue'
import { computed, provide } from 'vue';
import { useRoute } from 'vue-router/composables';
import store from '@/store';
import { ANGULAR_BRIDGE } from '@/composables/useAngularBridge';
import CLoader from '@/components/shared/CLoader.vue';

interface BreadcrumbItem {
    name: string;
    href: string;
    link?: string;
}

// Handled by VueRouterWrapperCtrl through the ng-vue v-on-* bindings

export default /*#__PURE__*/_defineComponent({
  __name: 'VueRouterWrapper',
  emits: ["navigate", "create-template", "edit-template"],
  setup(__props, { emit }: { emit: ({
    (event: 'navigate', url: string, replace?: boolean): void;
    (event: 'create-template'): void;
    (event: 'edit-template', templateId: string): void;
}), expose: any, slots: any, attrs: any }) {



provide(ANGULAR_BRIDGE, {
    navigate: (url, replace) => emit('navigate', url, replace),
    createTemplate: () => emit('create-template'),
    editTemplate: (templateId) => emit('edit-template', templateId)
});

const route = useRoute();

const breadcrumbItems = computed(() => {
    const breadcrumbs: BreadcrumbItem[] = route.meta?.breadcrumb || [];
    return breadcrumbs.map((b) => ({
        to: b.link,
        text: b.name,
        href: b.href
    }));
});

const loader = computed(() => {
    const state = store.state.loader;
    return {
        value: state.active,
        text: state.text
    };
});

return { __sfc: true,emit, route, breadcrumbItems, loader, CLoader }
}

})